<template>
  <article id="contact" class="layout-section -align-side">
    <a v-if="content.mapLink" v-scroll:reveal :href="content.mapLink" target="_blank" class="layout-section__figure" :style="image" />
    <span v-else v-scroll:reveal class="layout-section__figure" :style="image" />

    <section>
      <div class="layout-section__hgroup">
        <h2 v-scroll:reveal="{delay:75}" class="layout-section__title">{{ content.title }}</h2>
        <p>{{ content.text }}</p>
      </div>

      <div class="contact">
        <section class="contact__item -alt">
          <svg-icon id="mail" />
          <a :href="`mailto:${content.email}`">{{ content.email }}</a>
        </section>

        <section class="contact__item">
          <svg-icon id="phone" />
          <p>{{ content.phone }}</p>
        </section>

        <section class="contact__item">
          <svg-icon id="location" />
          <a :href="content.mapLink" target="_blank">{{ content.address }}</a>
        </section>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'HomeContact',
  computed: {
    content() {
      return this.$i18n.t('contact')
    },
    image() {
      return { backgroundImage: `url('${this.content.image}')` }
    }
  }
}
</script>
